import * as React from "react";
const SvgClose = (props) => /* @__PURE__ */ React.createElement("svg", { width: 22, height: 22, viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M1 1L21 21M21 1L1 21", stroke: "#0F1C37", strokeWidth: 2, strokeLinecap: "round" }));
export default SvgClose;
